<template>
  <div>
    <p class="mb-0">
      Which of the following would
      <span class="text-bold text-danger">decrease</span>
      the rate of a second order reaction?
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing" class="mt-1 pl-6 mb-n6">
        <div v-for="option in options1" :key="option.value">
          <v-radio class="d-inline-block" :value="option.value" />
          <stemble-latex :content="option.expression" />
        </div>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question170g',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
      options1: [
        {expression: '$\\text{Adding a catalyst}$', value: 'catalyst'},
        {
          expression: '$\\text{Increasing the surface area of a reagent}$',
          value: 'surfaceArea',
        },
        {
          expression: '$\\text{Decreasing the concentration of a reagent}$',
          value: 'decreaseConc',
        },
        {
          expression: '$\\text{Increasing the temperature}$',
          value: 'increaseT',
        },
        {
          expression: '$\\text{Adding product to the system}$',
          value: 'addProduct',
        },
      ],
    };
  },
};
</script>
